export default __webpack_public_path__ + "static/media/fMaltoBuza34.2efe0e07.png";